<template>
  <v-sheet
    :width="size"
    :height="size"
    :color="`rgba( 0, 0, 0, ${opacity} )`"
    rounded
    class="rating-circle d-flex rounded-pill align-center"
  >
    <v-progress-circular :value="rating * 10" :rotate="-90" :size="size" :width="strokeWidth" dark :color="strokeColor">
      <div class="rating-text">{{ roundedRating }}</div>
    </v-progress-circular>
  </v-sheet>
</template>

<style scoped>
.d-flex {
  justify-content: center;
}

.v-progress-circular {
  flex: 1;
}

.v-progress-circular >>> .v-progress-circular__underlay {
  stroke: rgba(255, 255, 255, 0.25);
}

.rating-text {
  font-family: "Saira", "serif";
  font-size: 200%;
  color: var(--text-inverted);
  letter-spacing: -0.18rem;
  text-indent: -0.18rem;
  text-align: center !important;
}
</style>

<script>
export default {
  name: "rating-circle-colored-ring",

  props: {
    rating: { type: Number, default: 0 },

    size: { type: Number, default: 64 },

    opacity: { type: Number, default: 0.9 },
  },

  computed: {
    strokeWidth: function () {
      return this.size * 0.075;
    },

    strokeColor() {
      return this.ratingColors[Math.round(this.rating) - 1];
    },

    roundedRating() {
      return this.rating % 1 === 0 ? parseInt(this.rating) : this.rating.toFixed(1);
    },
  },

  data: () => ({
    ratingColors: [
      "#880000",
      "#bf0000",
      "#ff4000",
      "#ff8000",
      "#ffbf00",
      "#ffff00",
      "#bfff00",
      "#80ff00",
      "#40ff00",
      "#00ff00",
    ],
  }),
};
</script>
